// extracted by mini-css-extract-plugin
export default {"btn_loading":"button-file_btn_loading__1zfk1","loading_cnt":"button-file_loading_cnt__s+NLF"};